<template>
<svg data-svg-lvl-3="cover-top-corners" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><linearGradient id="tcr-lg" x1="369.3" y1="15618.65" x2="369.3" y2="15611.42" gradientTransform="matrix(1, 0, 0, -1, 0, 16037.72)" gradientUnits="userSpaceOnUse">
<template v-if="params.cornersColor === '#9C6B00'">
  <!--  Золото -->
  <stop offset="0" stop-color="#9c6b00" />
  <stop offset="0.18" stop-color="#fbe6a6" />
  <stop offset="0.31" stop-color="#d4a94c" />
  <stop offset="0.61" stop-color="#e1bd69" />
  <stop offset="0.86" stop-color="#6c4209" />
</template>
<template v-else>
  <!-- Серебро -->
  <stop offset="0" stop-color="#989ba0" />
  <stop offset=".18" stop-color="#fff" />
  <stop offset=".31" stop-color="#989ba0" />
  <stop offset=".61" stop-color="#babdc4" />
  <stop offset=".86" stop-color="#3c3e45" />
</template>
</linearGradient><linearGradient id="tcr-lg-2" x1="383.59" y1="15632.6" x2="390.52" y2="15632.6" href="#tcr-lg"/><linearGradient id="tcr-lg-3" x1="369.3" y1="26.67" x2="369.3" y2="33.91" gradientUnits="userSpaceOnUse">
<template v-if="params.cornersColor === '#9C6B00'">
  <!--  Золото -->
  <stop offset="0" stop-color="#9c6b00" />
  <stop offset="0.18" stop-color="#fbe6a6" />
  <stop offset="0.31" stop-color="#d4a94c" />
  <stop offset="0.58" stop-color="#fbe6a6" />
  <stop offset="0.65" stop-color="#f9e4a4" />
  <stop offset="0.7" stop-color="#f2db9c" />
  <stop offset="0.73" stop-color="#e5cd8e" />
  <stop offset="0.76" stop-color="#d4b97b" />
  <stop offset="0.79" stop-color="#bd9f62" />
  <stop offset="0.82" stop-color="#a17f43" />
  <stop offset="0.84" stop-color="#815a20" />
  <stop offset="0.86" stop-color="#6c4209" />
</template>
<template v-else>
  <!-- Серебро -->
  <stop offset="0" stop-color="#989ba0" />
  <stop offset=".18" stop-color="#fff" />
  <stop offset=".31" stop-color="#989ba0" />
  <stop offset=".58" stop-color="#edf1fa" />
  <stop offset=".65" stop-color="#eaeef7" />
  <stop offset=".69" stop-color="#e2e6ef" />
  <stop offset=".73" stop-color="#d4d8e1" />
  <stop offset=".76" stop-color="#c0c4cc" />
  <stop offset=".79" stop-color="#a7aab2" />
  <stop offset=".81" stop-color="#888a92" />
  <stop offset=".84" stop-color="#63666d" />
  <stop offset=".86" stop-color="#3c3e45" />
</template>
</linearGradient><linearGradient id="tcr-lg-4" x1="390.41" y1="48.04" x2="383.48" y2="48.04" gradientUnits="userSpaceOnUse">
<template v-if="params.cornersColor === '#9C6B00'">
  <!--  Золото -->
  <stop offset="0" stop-color="#9c6b00" />
  <stop offset="0.18" stop-color="#fbe6a6" />
  <stop offset="0.31" stop-color="#d4a94c" />
  <stop offset="0.32" stop-color="#d8b056" />
  <stop offset="0.37" stop-color="#e5c373" />
  <stop offset="0.41" stop-color="#efd38a" />
  <stop offset="0.46" stop-color="#f6de9a" />
  <stop offset="0.52" stop-color="#fae4a3" />
  <stop offset="0.59" stop-color="#fbe6a6" />
  <stop offset="1" stop-color="#6c4209" />
</template>
<template v-else>
  <!-- Серебро -->
  <stop offset="0" stop-color="#989ba0" />
  <stop offset=".18" stop-color="#fff" />
  <stop offset=".31" stop-color="#989ba0" />
  <stop offset=".32" stop-color="#a1a4aa" />
  <stop offset=".37" stop-color="#bcc0c7" />
  <stop offset=".41" stop-color="#d2d5dd" />
  <stop offset=".46" stop-color="#e1e5ed" />
  <stop offset=".52" stop-color="#eaeef7" />
  <stop offset=".59" stop-color="#edf1fa" />
  <stop offset="1" stop-color="#3c3e45" />
</template>
</linearGradient></defs><g id="УголкиКрышка"><line class="tcr-c-3" x1="357.88" y1="35.97" x2="383.35" y2="35.97"/><line class="tcr-c-4" x1="357.71" y1="35.79" x2="383.35" y2="35.79"/><line class="tcr-c-5" x1="357.54" y1="35.61" x2="383.35" y2="35.61"/><line class="tcr-c-6" x1="357.37" y1="35.43" x2="383.35" y2="35.43"/><line class="tcr-c-7" x1="357.2" y1="35.25" x2="383.35" y2="35.25"/><line class="tcr-c-8" x1="357.03" y1="35.07" x2="383.35" y2="35.07"/><line class="tcr-c-9" x1="356.86" y1="34.89" x2="383.35" y2="34.89"/><line class="tcr-c-10" x1="356.69" y1="34.71" x2="383.35" y2="34.71"/><line class="tcr-c-11" x1="356.52" y1="34.53" x2="383.35" y2="34.53"/><line class="tcr-c-12" x1="356.35" y1="34.34" x2="383.35" y2="34.34"/><line class="tcr-c-13" x1="356.18" y1="34.16" x2="383.35" y2="34.16"/><line class="tcr-c-14" x1="356.01" y1="33.98" x2="383.35" y2="33.98"/><path class="tcr-c-15" d="M388,426.46H348.73l7.28-7.29h27.34l6.53,6.52A2.61,2.61,0,0,1,388,426.46Z"/><path class="tcr-c-16" d="M383.35,419.17V391.83l7.29-7.29v39.3a2.62,2.62,0,0,1-.76,1.85Z"/><path class="tcr-c-17" d="M390.64,384.54v39.3a2.62,2.62,0,0,1-2.62,2.62H348.73l7.28-7.29h27.34V391.83l7.29-7.29m-.8-.8L382.55,391l-.34.34V418H355.54l-.33.33-7.29,7.29.81,2H388a3.76,3.76,0,0,0,3.76-3.76v-39.3l-1.94-.8Z"/><path class="tcr-c-18" d="M388,26.69H348.73L356,34h27.34l6.53-6.52A2.65,2.65,0,0,0,388,26.69Z"/><path class="tcr-c-19" d="M383.35,34V61.32l7.29,7.29V29.31a2.63,2.63,0,0,0-.76-1.85Z"/><path class="tcr-c-17" d="M388,26.69a2.62,2.62,0,0,1,2.62,2.62v39.3l-7.29-7.29V34H356l-7.28-7.29H388m0-1.14H348.73l-.81,1.95,7.29,7.29.33.34h26.67V61.8l.34.33,7.29,7.29,1.94-.81V29.31A3.76,3.76,0,0,0,388,25.55Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.tcr-c-1{opacity:0.3;}.tcr-c-2{fill:#64ff00;}.tcr-c-10,.tcr-c-11,.tcr-c-12,.tcr-c-13,.tcr-c-14,.tcr-c-3,.tcr-c-4,.tcr-c-5,.tcr-c-6,.tcr-c-7,.tcr-c-8,.tcr-c-9{fill:none;stroke:#000;stroke-miterlimit:2;stroke-width:0.5px;}.tcr-c-3{opacity:0;}.tcr-c-4{opacity:0.05;}.tcr-c-5{opacity:0.09;}.tcr-c-6{opacity:0.14;}.tcr-c-7{opacity:0.18;}.tcr-c-8{opacity:0.23;}.tcr-c-9{opacity:0.27;}.tcr-c-10{opacity:0.32;}.tcr-c-11{opacity:0.36;}.tcr-c-12{opacity:0.41;}.tcr-c-13{opacity:0.45;}.tcr-c-14{opacity:0.5;}.tcr-c-15{fill:url(#tcr-lg);}.tcr-c-16{fill:url(#tcr-lg-2);}.tcr-c-17{fill:#232728;}.tcr-c-18{fill:url(#tcr-lg-3);}.tcr-c-19{fill:url(#tcr-lg-4);}</style>

